import React from "react";
import { Box, Grid2, useTheme } from "@mui/material";
import {
  OcRoleFilterSubtype,
  OcRoleFilterSubtypeProps,
} from "oc/components/role-filter-subtype";

export const OcRoleFilterGroupedSubtypes: React.FC<
  Omit<OcRoleFilterSubtypeProps, "type" | "useOcFiltersData">
> = (subtypeProps) => {
  const theme = useTheme();

  return (
    <Grid2
      container
      spacing={2}
      sx={{
        display: "flex",
      }}
    >
      <OcRoleFilterSubtype {...subtypeProps} type="company" />
      <OcRoleFilterSubtype {...subtypeProps} type="orgUnit" />
      <OcRoleFilterSubtype {...subtypeProps} type="workingPlace" />
      <OcRoleFilterSubtype {...subtypeProps} type="jobClassGroup" />
      <OcRoleFilterSubtype {...subtypeProps} type="payOffice" />
      <Grid2 size={12}>
        <Box height="1px" bgcolor={theme.palette.gray40.main} />
      </Grid2>
      <OcRoleFilterSubtype {...subtypeProps} type="contract" />
    </Grid2>
  );
};
